import React, {CSSProperties, ReactNode} from 'react';

interface Props {
    children: ReactNode;
    style?: CSSProperties;
    className?: string;
}

export function Container(props: Props) {
    const style = {
        margin: 16,
        ...props.style,
    };
    return (
        <div style={style}>
            {props.children}
        </div>
    );
}